import { render, staticRenderFns } from "./OccurrenceChart.vue?vue&type=template&id=2e36f6cc"
import script from "./OccurrenceChart.vue?vue&type=script&lang=js"
export * from "./OccurrenceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports